import { FACILITATIONS } from "./facilitations";
import { FINANCE } from "./finance";

import { SERVICES } from "./services";

export const SUB_MENUS = {
  finance: {
    marginTop: "6rem",
    options: Object.keys(FINANCE).map((key) => {
      return {
        title: FINANCE[key].title,
        link: FINANCE[key].button.link,
      };
    }),
  },
  facilitations: {
    marginTop: "8.5em",
    options: Object.keys(FACILITATIONS).map((key) => {
      return {
        title: FACILITATIONS[key].title,
        link: FACILITATIONS[key].button.link,
      };
    }),
  },
  services: {
    marginTop: "6rem",
    options: Object.keys(SERVICES).map((key) => {
      return {
        title: SERVICES[key].title,
        link: SERVICES[key].button.link,
      };
    }),
  },
};
